/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    name: 'c-frequency-bar',
})
export default class FrequencyBar extends Vue {
    public frequencies: {fid: number, name: string}[] = [];

    @Prop() private title!: string;
    @Prop() private currentFrequencyId!: number;


    /**
     * Mounted life-cycle event.
     *
     * Initialises the loader.
     */
    public mounted(): void {

        // todo Get the frequencies
        this.frequencies = [
            {fid: 1, name: 'Rarely'},
            {fid: 2, name: 'Sometimes'},
            {fid: 3, name: 'Often'},
            {fid: 4, name: 'Frequently'},
            {fid: 5, name: 'Always'},

        ];
    }

}
